import React from "react";
import PropTypes from "prop-types";
import DetailDesktop from "./DetailDesktop";

function Detail({ app, config }) {
  return <DetailDesktop app={app} config={config} />;
}

Detail.defaultProps = {
  app: null,
  config: {},
};

Detail.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default Detail;
